"use client";

import ParticipantSurveySection from "@/features/participant/components/ParticipantSurveySection";
import { buildParticipantSurveyItems } from "@/features/participant/components/participantSurvey";

type PreSurveyCheckInSectionProps = {
  pain: number;
  energy: number;
  positivity: number;
  onPainChange: (value: number) => void;
  onEnergyChange: (value: number) => void;
  onPositivityChange: (value: number) => void;
};

export default function PreSurveyCheckInSection({
  pain,
  energy,
  positivity,
  onPainChange,
  onEnergyChange,
  onPositivityChange,
}: PreSurveyCheckInSectionProps) {
  const sliderItems = buildParticipantSurveyItems({
    phase: "pre",
    pain,
    energy,
    positivity,
    onPainChange,
    onEnergyChange,
    onPositivityChange,
  });

  return (
    <ParticipantSurveySection
      headingId="presurvey-checkin"
      title="Check-in"
      description="Rate how you feel right now before you capture baseline and begin the session."
      className="!min-h-0 gap-0 overflow-hidden rounded-[var(--radius-lg)] px-0 py-0 xl:self-start xl:max-w-none"
      headerClassName="psone-dark-container theme-menu-header px-4 py-4 sm:px-5"
      contentClassName="mt-0 px-4 py-4 sm:px-5"
      items={sliderItems}
    />
  );
}
